// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1206":"12c9035b","4642":"704618a5","8343":"ae6051a3","8607":"ebf54322","9413":"b001ee5f"}[chunkId] + ".chunk.css";
};